import axios from "axios";

// Helper function to extract error messages
export const extractErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const response = error.response;

    // Try to extract common error message patterns
    if (response?.data) {
      if (typeof response.data === "string") {
        return response.data;
      }

      if (response.data.message) {
        return response.data.message;
      }

      // Some APIs send errors like { error: "something went wrong" }
      if (response.data.error) {
        return response.data.error;
      }

      // Laravel-style errors in { errors: { field: ["message"] } }
      if (response.data.errors && typeof response.data.errors === "object") {
        const firstKey = Object.keys(response.data.errors)[0];
        return response.data.errors[firstKey][0];
      }
    }

    return error.message;
  }

  // Fallback for non-Axios errors
  return (error as Error)?.message || "An unknown error occurred";
};
